import React from 'react';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { DiscordIcon } from '@/ui/Icons/DiscordIcon';
import { DocumentIcon } from '@/ui/Icons/DocumentIcon';
import { FaqIcon } from '@/ui/Icons/FaqIcon';
import { RocketIcon } from '@/ui/Icons/RocketIcon';
import { TwitterIcon } from '@/ui/Icons/TwitterIcon';
import { WalletIcon } from '@/ui/Icons/WalletIcon';
import { ExternalLink } from '@/ui/Link/ExternalLink';

import { routes } from '@/utils/routes';

const links = [
  {
    title: 'Getting Started',
    Icon: RocketIcon,
    url: routes.HELP_GETTING_STARTED,
  },
  {
    title: 'FAQs',
    Icon: FaqIcon,
    url: routes.HELP_FAQ,
  },
  {
    title: 'Wallets',
    Icon: WalletIcon,
    url: routes.HELP_WALLETS,
  },
  {
    title: 'Discord',
    Icon: DiscordIcon,
    url: routes.DISCORD,
  },
  {
    title: 'x.com',
    Icon: TwitterIcon,
    url: routes.TWITTER,
  },
  {
    title: 'Blog',
    Icon: DocumentIcon,
    url: routes.BLOG,
  },
];

const LandingHelpComponent = () => (
  <div className="tablet:mb-16 max-w-[1240px] mx-auto mb-8 w-full">
    <h5 className={fontStyles({ variant: 'H5', class: 'tablet:text-left mb-8 text-center' })}>
      Need help with something?
    </h5>
    <div className="tablet:justify-start mb-26 flex flex-wrap justify-center gap-4">
      {links.map(({ title, Icon, url }) => (
        <ExternalLink
          className={buttons({
            size: 'large',
            color: 'gray',
            shape: 'pill',
            class: 'flex h-fit w-fit items-center justify-center gap-x-2 px-5 py-4',
          })}
          href={url}
          key={title}
        >
          <Icon className="text-token-gray-700" />
          <span>{title}</span>
        </ExternalLink>
      ))}
    </div>
  </div>
);
export const LandingHelp = React.memo(LandingHelpComponent);
